import {useDataSource} from "../../hooks/useContextDataSource";
import {useLocalization} from "../../../../../../../customHooks/useContextLocalization";


export default function ({selectedNodeId, handleServerMapTableShowing}) {
    const {dataSources, dispatch} = useDataSource();
    const locale = useLocalization();

    const setDataSourceOfNode = event => {
        dispatch({
            type: "Add or update data source",
            id: selectedNodeId,
            data: {source: event.target.value}
        });
        handleServerMapTableShowing(event.target.value === "server");
    };

    return <div className="project-analytics-source-node-configurator-option-container">
        <div>
            <input
                type="radio"
                id="use-server-data"
                name="data-source"
                value="server"
                checked={dataSources[selectedNodeId]?.source === "server"}
                onChange={setDataSourceOfNode}
            />
            <label htmlFor="use-server-data">
                {locale?.get?.project.analytics.mainPage.dfd.configurator.useServerData}
            </label>
        </div>
        <div>
            <input
                type="radio"
                id="use-local-data"
                name="data-source"
                value="local"
                checked={dataSources[selectedNodeId]?.source === "local"}
                onChange={setDataSourceOfNode}
            />
            <label htmlFor="use-local-data">
                {locale?.get?.project.analytics.mainPage.dfd.configurator.useLocalData}
            </label>
        </div>
    </div>;
}
